import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getResultsVersion = (state: ContentPluginRootState) => state.data.results?.resultsVersion;

export default getResultsVersion;
